import {
  type KeyOfType,
  getValueFromKeyOfType,
} from '../../../types/KeyOfType';
import { createDefaultFilter } from '../../filters/createDefaultFilter';
import { createLabelsFilter } from '../../filters/types/labelsFilter';
import type { TableColumnBase } from '../TableColumnBase';
import {
  type TableDataColumnConfig,
  pickTableColumnConfig,
} from '../TableColumnConfig';
import { formatValueToCsvString } from './helpers/formatValueToCsvString';

export type LabelTargetType = 'device' | 'intL2';

export type TableColumnFormatLabels<TRow> = {
  type: 'labels';
  field: KeyOfType<TRow, string[] | null>;
  targetIdField: KeyOfType<TRow, string>;
  targetType: LabelTargetType;
};

export const createLabelsColumn = <TRow>(
  config: TableDataColumnConfig<TRow, string[] | null> & {
    targetIdField: KeyOfType<TRow, string>;
    targetType: LabelTargetType;
  },
): TableColumnBase<TRow, TableColumnFormatLabels<TRow>> => {
  return {
    ...pickTableColumnConfig(config),
    array: true,
    format: {
      type: 'labels',
      field: config.key,
      targetIdField: config.targetIdField,
      targetType: config.targetType,
    },
    csvStringDependencies: [config.key],
    webDependencies: [config.key, config.targetIdField],
    toCsvString: (row) =>
      formatValueToCsvString(
        getValueFromKeyOfType<TRow, string[] | null>(row, config.key),
        (v: string | null): string => v ?? '',
      ),
    filter: createDefaultFilter(config.filter, createLabelsFilter()),
  };
};
